export var iconTokens = {
  size: {
    xs: '1rem',
    s: '1.2rem',
    m: '1.6rem',
    l: '2rem',
    xl: '3.2rem'
  }
};